/**
 * Converts Persian digits to English digits
 */
export const convertPersianToEnglish = (input) => {
  if (!input) return input;
  
  return String(input)
    .replace(/۰/g, '0')
    .replace(/۱/g, '1')
    .replace(/۲/g, '2')
    .replace(/۳/g, '3')
    .replace(/۴/g, '4')
    .replace(/۵/g, '5')
    .replace(/۶/g, '6')
    .replace(/۷/g, '7')
    .replace(/۸/g, '8')
    .replace(/۹/g, '9');
};

/**
 * Normalizes and formats mobile number to +989XXXXXXXXX format
 * Accepts: 09123456789, 9123456789, 989123456789, +989123456789
 * Returns: +989123456789
 */
export const normalizeMobileNumber = (mobile) => {
  if (!mobile) return null;

  // Convert Persian digits to English
  let normalized = convertPersianToEnglish(mobile.trim());

  // Remove all non-digit characters except +
  normalized = normalized.replace(/[^0-9+]/g, '');

  // Handle different formats
  if (normalized.startsWith('+98')) {
    // Already in +98 format
    normalized = normalized.substring(0, 13); // +989XXXXXXXXX = 13 chars
  } else if (normalized.startsWith('98')) {
    // 98XXXXXXXXXX format
    normalized = '+' + normalized.substring(0, 12); // 98XXXXXXXXXX = 12 digits
  } else if (normalized.startsWith('09')) {
    // 09XXXXXXXXX format
    normalized = '+98' + normalized.substring(1); // Remove 0, add +98
  } else if (normalized.startsWith('9') && normalized.length === 10) {
    // 9XXXXXXXXX format (10 digits)
    normalized = '+98' + normalized;
  } else {
    // Try to fix if it's 11 digits starting with 0
    if (normalized.length === 11 && normalized.startsWith('0')) {
      normalized = '+98' + normalized.substring(1);
    } else if (normalized.length === 10 && normalized.startsWith('9')) {
      normalized = '+98' + normalized;
    }
  }

  // Validate final format: +989XXXXXXXXX (13 characters total)
  if (normalized.length === 13 && normalized.startsWith('+989') && 
      /^\+989[0-9]{9}$/.test(normalized)) {
    return normalized;
  }

  // If validation fails, return null
  return null;
};

/**
 * Converts English digits to Persian digits
 */
export const convertEnglishToPersian = (input) => {
  if (!input && input !== 0) return input;
  
  return String(input)
    .replace(/0/g, '۰')
    .replace(/1/g, '۱')
    .replace(/2/g, '۲')
    .replace(/3/g, '۳')
    .replace(/4/g, '۴')
    .replace(/5/g, '۵')
    .replace(/6/g, '۶')
    .replace(/7/g, '۷')
    .replace(/8/g, '۸')
    .replace(/9/g, '۹');
};

/**
 * Formats mobile number for display (removes +98 and shows 09XXXXXXXXX in Persian)
 */
export const formatMobileForDisplay = (mobile) => {
  if (!mobile) return '';
  
  let formatted = mobile;
  if (mobile.startsWith('+98')) {
    formatted = '0' + mobile.substring(3);
  }
  
  // Convert to Persian digits
  return convertEnglishToPersian(formatted);
};

/**
 * Formats number with Persian digits (for display)
 */
export const formatNumberPersian = (number) => {
  if (number === null || number === undefined) return '';
  return convertEnglishToPersian(number);
};

